import { gql } from '@apollo/client'

export const CHATBOT_QUICK_PROMPT_FIELDS = gql`
  fragment ChatbotQuickPromptFields on ChatbotQuickPrompt {
    id
    title
    text
    custom
    createdAt
  }
`
